import {
  Grid,
  TextField,
  Table,
  TableCell,
  TableBody,
  TableRow
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import _ from 'lodash';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PageHeader from '../common/PageHeader';
import ReportButtons from './ReportButtons';
import AdvancedFilter from './AdvancedFilter';
import {
  EnhancedTableHead,
  GenerateAbsoluteURL,
  getCurrentPayCycleEndDateByDate,
  getCurrentPayCycleStartDateByDate,
  removeDuplicates,
  orderBy, orderByMultiple,
  getPreviousPayCycle,
  disableDatesForPayCycleStart1,
  disableDatesForPayCycleEnd1,
  getNumberOfPayCycle,
  getMaxDate,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import { getMultilevelGroupedData } from '../../utils/generic';
import { getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

// Column header array
const headCells = [
  {
    id: 'previousAllocationPercent',
    numeric: true,
    disablePadding: true,
    label: 'Previous Allocation %',
    type: 'Number',
    isSort: false
  },
  {
    id: 'rate',
    numeric: true,
    disablePadding: true,
    label: 'Allocation %',
    type: 'Number',
    isSort: false
  },
  {
    id: 'allocationPercentVariance',
    numeric: true,
    disablePadding: true,
    label: 'Allocation Variance',
    type: 'Number',
    isSort: false
  },
  {
    id: 'previousBillingPercent',
    numeric: true,
    disablePadding: true,
    label: 'Previous Billing %',
    type: 'Number',
    isSort: false
  },
  {
    id: 'billingPercent',
    numeric: true,
    disablePadding: true,
    label: 'Billing %',
    type: 'Number',
    isSort: false
  },
  {
    id: 'billingPercentVariance',
    numeric: true,
    disablePadding: true,
    label: 'Billing Variance',
    type: 'Number',
    isSort: false
  },
  {
    id: 'previousFixedAmount',
    numeric: true,
    disablePadding: true,
    label: 'Previous Fixed Amount',
    type: 'Number',
    isSort: false
  },
  {
    id: 'fixedAmount',
    numeric: true,
    disablePadding: true,
    label: 'Fixed Amount',
    type: 'Number',
    isSort: false
  },
  {
    id: 'fixedAmountVariance',
    numeric: true,
    disablePadding: true,
    label: 'Fixed Amount Variance',
    type: 'Number',
    isSort: false
  },
  {
    // key: 'Billable',
    // value: 'billable',
    // ssrsReport: 'Billable',
    numeric: false,
    disablePadding: false,
    label: 'Previous Billable',
    type: 'Text',
    id: 'previousIsBilable',
    isSort: false
  },
  {
    // key: 'Billable',
    // value: 'billable',
    // ssrsReport: 'Billable',
    numeric: false,
    disablePadding: false,
    label: 'Billable',
    type: 'Text',
    id: 'billable',
    isSort: false
  },
  {
    id: 'effectiveFrom',
    numeric: false,
    disablePadding: true,
    label: 'Effective From',
    type: 'Text',
    isSort: false
  },
  {
    id: 'effectiveThrough',
    numeric: false,
    disablePadding: true,
    label: 'Effective Through',
    type: 'Text',
    isSort: false
  }
];
let temcurrentGroupedRow = [];

export default class PropertyAllocationSummary extends Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      employeeData: [],      
      startDate: getPreviousPayCycle().previousPayCycleStartDate,
      endDate: getPreviousPayCycle().previousPayCycleEndDate,
      futureEndDate: getCurrentPayCycleEndDateByDate(moment().format(DateFormat)),
      showReport: false,
      marketMasterData: [],
      departmentMasterData: [],
      designationMasterData: [],
      propertyMasterData: [],
      employeeMasterData: [],
      propertyTypeMasterData: [],
      propertySubTypeData: [],
      clientListingMasterData: [],
      legalEntityMasterData: [],
      //   employeeSupervisorList: [],
      market: [{ marketName: 'All' }],
      designation: [{ designation: 'All' }],
      department: [{ departmentName: 'All' }],
      //   supervisor: [{ supervisorName: 'All' }],
      property: [{ propertyName: 'All' }],
      employee: [{ employeeName: 'All' }],
      SupervisorEmployee: [{ employeeName: 'All' }],
      controllerEmployee: [{ employeeName: 'All' }],
      propertyType: [{ propertyTypeName: 'All' }],
      propertySubType: [{ propertySubTypeName: 'All' }],
      client: [{ clientName: 'All' }],
      legalEntity: [{ customerName: 'All' }],
      supervisorEmployeeMasterData: [],
      controllerEmployeeMasterData: [],
      openSlidingPanel: false,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      advanceFilterConfig: {
        groupBy: {
          masterData: [{
            key: 'Market',
            value: 'allocatedMarket',
            id: 'allocatedMarket',
            ssrsReport: 'Market',
            numeric: false,
            disablePadding: false,
            label: 'Market',
            type: 'Text',
            order: 1
          },
          {
            key: 'Property Code',
            value: 'propertyCode',
            id: 'propertyCode',
            ssrsReport: 'PropertyCode',
            numeric: false,
            disablePadding: false,
            label: 'Property Code',
            type: 'Text',
            order: 2
          },
          {
            key: 'Property Name',
            value: 'property',
            id: 'property',
            ssrsReport: 'Property',
            numeric: false,
            disablePadding: false,
            label: 'Property Name',
            type: 'Text',
            order: 3
          },
          {
            key: 'Legal Entity',
            id: 'legalEntity',
            value: 'legalEntity',
            ssrsReport: 'LegalEntity',
            numeric: false,
            disablePadding: false,
            label: 'Legal Entity',
            type: 'Text',
            order: 4
          },
          {
            key: 'Client',
            value: 'client',
            id: 'client',
            ssrsReport: 'Client',
            numeric: false,
            disablePadding: false,
            label: 'Client',
            type: 'Text',
            order: 5
          },
          {
            key: 'Property Type',
            value: 'propertyType',
            ssrsReport: 'PropertyType',
            numeric: false,
            disablePadding: false,
            label: 'Property Type',
            type: 'Text',
            id: 'propertyType',
            order: 6
          },
          {
            key: 'Property Sub Type',
            value: 'propertySubType',
            ssrsReport: 'PropertySubType',
            numeric: false,
            disablePadding: false,
            label: 'Property Sub Type',
            type: 'Text',
            id: 'propertySubType',
            order: 7
          },
          {
            key: 'Source Accounting System',
            value: 'sourceAccountingSystem',
            ssrsReport: 'SourceAccountingSystem',
            numeric: false,
            disablePadding: false,
            label: 'Source Accounting System',
            type: 'Text',
            id: 'sourceAccountingSystem',
            order: 8
          },
          {
            key: 'Employee Name',
            value: 'employeeName',
            id: 'employeeName',
            ssrsReport: 'EmployeeName',
            numeric: false,
            disablePadding: false,
            label: 'Employee Name',
            type: 'Text',
            order: 9
          },
          {
            key: 'Employee Id',
            value: 'employeeCode',
            id: 'employeeCode',
            ssrsReport: 'EmployeeCode',
            numeric: false,
            disablePadding: false,
            label: 'Employee Id',
            type: 'Text',
            order: 10
          },
          {
            key: 'Supervisor Name',
            value: 'supervisorName',
            id: 'supervisorName',
            ssrsReport: 'SupervisorName',
            numeric: false,
            disablePadding: false,
            label: 'Supervisor Name',
            type: 'Text',
            order: 11
          },
          {
            key: 'Controller Name',
            value: 'controllerName',
            id: 'controllerName',
            ssrsReport: 'ControllerName',
            numeric: false,
            disablePadding: false,
            label: 'controller Name',
            type: 'Text',
            order: 12
          },
          {
            key: 'Home Department',
            value: 'homeDepartment',
            ssrsReport: 'HomeDepartment',
            numeric: false,
            disablePadding: false,
            label: 'Home Department',
            type: 'Text',
            id: 'homeDepartment',
            order: 13
          },
          {
            key: 'Expense Account',
            value: 'expenseAccount',
            ssrsReport: 'ExpenseAccount',
            numeric: false,
            disablePadding: false,
            label: 'Expense Account',
            type: 'Text',
            id: 'expenseAccount',
            order: 14
          }          
          ],
          selected: []
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: false,
        summaryRows: false,
        showZeroNGraph: false,
        startDate: getPreviousPayCycle().previousPayCycleStartDate,
        endDate: getPreviousPayCycle().previousPayCycleEndDate,
        order: 'asc',
        orderBy: 'nam'
      }
    };

    this.baseState = this.state;
  }

  // Method to get data before components are mounted 
  componentDidMount() {
    this.GetMasterData();
  }

  // Get all master data using API call to fill filters
  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData'
      },
      {
        url: API_URL.Employee.GetDesignationMasterData,
        key: 'designationMasterData'
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: "propertyTypeData",
      },
      {
        url: API_URL.Property.GetPropertySubType,
        key: 'propertySubTypeData'
      },
      {
        url: API_URL.Transition.GetClientListingData,
        key: 'clientListingMasterData',
        fromCache: true,
        duration: 1
      },
      {
        url: API_URL.Transition.GetCustomerListingData,
        key: 'legalEntityMasterData',
        fromCache: true,
        duration: 1
      },
      {
        url:
          API_URL.Employee.GetControllerDetail +
          '?outputType=List',
        key: 'controllerEmployeesMasterData',
        fromCache: true,
        duration: 15
      },
      // {
      //   url: API_URL.Employee.GetEmployeeSupervisorList,
      //   key: 'employeeSupervisorList'
      // }
    ])
      .then(
        ({
          marketMasterData,
          departmentMasterData,
          designationMasterData,
          employeeMasterData,
          propertyMasterData,
          propertyTypeData,
          propertySubTypeData,
          clientListingMasterData,
          legalEntityMasterData,
          controllerEmployeesMasterData
        }) => {
          this._asyncRequest = null;
          if (marketMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }

          this.setState({
            marketMasterData: marketMasterData.data,
            departmentMasterData: departmentMasterData.data,
            designationMasterData: designationMasterData.data,
            employeeMasterData: employeeMasterData.data,
            propertyMasterData: propertyMasterData.data,
            supervisorEmployeeMasterData: employeeMasterData.data || [],
            propertyTypeMasterData: propertyTypeData.data || [],
            propertySubTypeData: propertySubTypeData.data || [],
            clientListingMasterData: clientListingMasterData.data,
            legalEntityMasterData: legalEntityMasterData.data,
            controllerEmployeeMasterData: (controllerEmployeesMasterData.data || [])
          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
              this.GetTerminatedEmployee();
            }            
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Go to report list
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Date change event of calendar.
  handleDateChange = (date, name) => {
    const { advanceFilterConfig, endDate } = this.state;
    localStorage.setItem('DateRadioSelect', 'CDR');
    let formattedDate = moment(date).format(DateFormat);
    const count = getNumberOfPayCycle(formattedDate, endDate);
    let futureEndDate = getMaxDate(formattedDate);
    
    if (name === 'startDate') {
      formattedDate = getCurrentPayCycleStartDateByDate(formattedDate).format(DateFormat);
      advanceFilterConfig.startDate = formattedDate; // moment(date).format(DateFormat);      
      localStorage.setItem('selectedstartDate', formattedDate);
      futureEndDate = moment(getCurrentPayCycleEndDateByDate(moment(formattedDate).format('MM/DD/YYYY'))).format('MM/DD/YYYY');
      this.setState({        
        [name]: formattedDate, // moment(date).format(DateFormat)
        futureEndDate,
        endDate: futureEndDate
      });
    } else {
      formattedDate = getCurrentPayCycleEndDateByDate(date).format(DateFormat);
      advanceFilterConfig.endDate = formattedDate; // moment(date).format(DateFormat);      
      localStorage.setItem('selectedendDate', formattedDate);
      this.setState({        
        [name]: formattedDate // moment(date).format(DateFormat)
      });
    }
  };

  // Disable other dates except pay cycle start dates (i.e. Excluding 1 & 16) on Pay Cycle Start calendar 
  disableDatesForPayCycleStart = (date) => {
    return disableDatesForPayCycleStart1(date);
  }

  // Disable other date except pay cycle end dates (i.e. excluding mid and last day of the month) on Pay Cycle End calendar
  disableDatesForPayCycleEnd = (date) => {
    return disableDatesForPayCycleEnd1(date);
  }

  // Get list of terminated employees
  GetTerminatedEmployee = () => {
    const {
      startDate,
      endDate,
      market,
      department,
      designation,
      property,
      employee,
      SupervisorEmployee,
      controllerEmployee,
      propertyType,
      propertySubType,
      client,
      legalEntity
    } =
      this.state;
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const designationId = _.cloneDeep(designation.map((x) => x.designationID));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const controllerEmployeeName = _.cloneDeep(controllerEmployee.map((x) => x.employeeName));
    const propertyTypeId = _.cloneDeep(propertyType.map((x) => x.propertyTypeId));
    const propertySubTypeId = _.cloneDeep(propertySubType.map((x) => x.propertySubTypeId));
    const clientId = _.cloneDeep(client.map((x) => x.clientId));
    const legalEntityId = _.cloneDeep(legalEntity.map((x) => x.customerId));


    const params = {
      startDate: moment(startDate).format(DateFormat),
      endDate: moment(endDate).format(DateFormat),
      marketId: marketId.join('|'),
      departmentId: departmentId.join('|'),
      designationId: designationId.join('|'),
      propertyId: propertyId.join('|'),
      employeeId: employeeId.join('|'),
      supervisorId: supervisorId.join('|'),
      controllerName: controllerEmployeeName.join('|') === 'All' ? '' : controllerEmployeeName.join('|'),
      propertyTypeId: propertyTypeId.join('|'),
      propertySubTypeId: propertySubTypeId.join('|'),
      clientId: clientId.join('|'),
      legalEntityId: legalEntityId.join('|')
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetPropertyAllocationSummary,
        params,
        key: 'propertyAllocationSummary'
      }
    ])
      .then(({ propertyAllocationSummary }) => {
        this._asyncRequest = null;
        if (propertyAllocationSummary.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        const UIData = this.renderTableRow(propertyAllocationSummary.data || []);
        this.setState({
          employeeData: propertyAllocationSummary.data,
          employeeSummary: propertyAllocationSummary.config,
          showReport: true,
          isSubmitButtonClicked: true,
          UIData: UIData
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  resetPage = () => {    
    const { advanceFilterConfig } = this.state;    
    advanceFilterConfig.groupBy = {
      masterData: [{
        key: 'Market',
        value: 'allocatedMarket',
        id: 'allocatedMarket',
        ssrsReport: 'Market',
        numeric: false,
        disablePadding: false,
        label: 'Market',
        type: 'Text',
        order: 1
      },
      {
        key: 'Property Code',
        value: 'propertyCode',
        id: 'propertyCode',
        ssrsReport: 'PropertyCode',
        numeric: false,
        disablePadding: false,
        label: 'Property Code',
        type: 'Text',
        order: 2
      },
      {
        key: 'Property Name',
        value: 'property',
        id: 'property',
        ssrsReport: 'Property',
        numeric: false,
        disablePadding: false,
        label: 'Property Name',
        type: 'Text',
        order: 3
      },
      {
        key: 'Legal Entity',
        id: 'legalEntity',
        value: 'legalEntity',
        ssrsReport: 'LegalEntity',
        numeric: false,
        disablePadding: false,
        label: 'Legal Entity',
        type: 'Text',
        order: 4
      },
      {
        key: 'Client',
        value: 'client',
        id: 'client',
        ssrsReport: 'Client',
        numeric: false,
        disablePadding: false,
        label: 'Client',
        type: 'Text',
        order: 5
      },
      {
        key: 'Property Type',
        value: 'propertyType',
        ssrsReport: 'PropertyType',
        numeric: false,
        disablePadding: false,
        label: 'Property Type',
        type: 'Text',
        id: 'propertyType',
        order: 6
      },
      {
        key: 'Property Sub Type',
        value: 'propertySubType',
        ssrsReport: 'PropertySubType',
        numeric: false,
        disablePadding: false,
        label: 'Property Sub Type',
        type: 'Text',
        id: 'propertySubType',
        order: 7
      },
      {
        key: 'Source Accounting System',
        value: 'sourceAccountingSystem',
        ssrsReport: 'sourceAccountingSystem',
        numeric: false,
        disablePadding: false,
        label: 'Source Accounting System',
        type: 'Text',
        id: 'sourceAccountingSystem',
        order: 8
      },
      {
        key: 'Employee Name',
        value: 'employeeName',
        id: 'employeeName',
        ssrsReport: 'EmployeeName',
        numeric: false,
        disablePadding: false,
        label: 'Employee Name',
        type: 'Text',
        order: 9
      },
      {
        key: 'Employee Code',
        value: 'employeeCode',
        id: 'employeeCode',
        ssrsReport: 'EmployeeCode',
        numeric: false,
        disablePadding: false,
        label: 'Employee Code',
        type: 'Text',
        order: 10
      },
      {
        key: 'Supervisor Name',
        value: 'supervisorName',
        id: 'supervisorName',
        ssrsReport: 'SupervisorName',
        numeric: false,
        disablePadding: false,
        label: 'Supervisor Name',
        type: 'Text',
        order: 11
      },
      {
        key: 'Controller Name',
        value: 'controllerName',
        id: 'controllerName',
        ssrsReport: 'controllerName',
        numeric: false,
        disablePadding: false,
        label: 'controller Name',
        type: 'Text',
        order: 12
      },
      {
        key: 'Home Department',
        value: 'homeDepartment',
        ssrsReport: 'HomeDepartment',
        numeric: false,
        disablePadding: false,
        label: 'Home Department',
        type: 'Text',
        id: 'homeDepartment',
        order: 13
      },
      {
        key: 'Expense Account',
        value: 'expenseAccount',
        ssrsReport: 'ExpenseAccount',
        numeric: false,
        disablePadding: false,
        label: 'Expense Account',
        type: 'Text',
        id: 'expenseAccount',
        order: 14
      }          
      ],
      selected: []
    };
    this.setState({
      ...this.baseState,
      isSubmitButtonClicked: false,
      advanceFilterConfig
    }, () => this.GetMasterData());    
  };

  // Run Report button click event
  handleSubmit = () => {
    localStorage.setItem('DateRadioSelect', 'CDR');
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);    
    this.GetTerminatedEmployee();
  };

  // Handle change event of filtered values
  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

  // Open sliding panel
  handleClickOpen = () => {
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    this.setState({
      openSlidingPanel: true
    });
  };

  // On change event of values in Advanced Filters. It will fetch the report based on advanced filters.
  onAddvanceFilterChange = (advanceFilterConfig) => {    
    this.setState(
      {
        advanceFilterConfig: advanceFilterConfig,
        openSlidingPanel: false        
      },
      () => this.GetTerminatedEmployee()
    );
  };

  // Get grouped column's sequence to display report by selected sequences in Advanced filters.
  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.groupBy.selected.length === 0) {
      return removeDuplicates(
        [
          // ...this.state.advanceFilterConfig.groupBy.selected,
          ...this.state.advanceFilterConfig.groupBy.masterData
        ],
        'key'
      );
    } else {
      return removeDuplicates(
        [
          ...this.state.advanceFilterConfig.groupBy.selected,
          ...this.state.advanceFilterConfig.groupBy.masterData
        ],
        'key'
      );
    }
  };

  //  Adjust column sequence
  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach((x) => {
      currentGroupedRow.push({ key: x.value });
    });
    return currentGroupedRow;
  };

  // Get grouped data as per groups selected in Advanced filers.
  getMultilevelGroupedSortedData = (data) => {
    data = orderBy(data, this.state.orderBy, this.state.order);
    const selectedGroupLength = this.state.advanceFilterConfig.groupBy.selected.length;
    if (selectedGroupLength > 0) {
      return orderByMultiple(data, this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value),
        this.state.advanceFilterConfig.groupBy.selected.map((x) => this.state.order),
        true);
    } else {
      return orderBy(data, this.state.orderBy, this.state.order);
    }
  };

  // Render data rows to display into table
  renderTableRow = (data) => {
    if (this.state.advanceFilterConfig.suppressZero === true) {
      data = data.filter((x) => {
        return (
          _.chain(x.reimbursmentDetails)
            .sumBy((x) => x.reimbursementCost)
            .value() !== 0
        );
      });
    }
    const selectedGroupLength = this.state.advanceFilterConfig.groupBy.selected.length;
    if (selectedGroupLength > 0) {
      temcurrentGroupedRow = [];
      return this.renderTableCell(
        getMultilevelGroupedData(
          data,
          this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value)
        ),
        []
      );
    } else {
      temcurrentGroupedRow = [];
      return this.renderTableCell(
        getMultilevelGroupedData(
          data,
          [] // this.state.advanceFilterConfig.groupBy.masterData.map((x) => x.value)
        ),
        []
      );
    }
  };

  // Render table cell with formatted data
  renderTableCell = (
    groupedData,
    currentGroupedRow = [],
    tableCell = [],
    rowCount = 0
  ) => {
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const sequence = this.getColumnSequence();
    
    groupedData.forEach((d, i) => {
      let column1 = (temcurrentGroupedRow.find(x => x.key === sequence[0].value) || {})?.value || null;
      let column2 = (temcurrentGroupedRow.find(x => x.key === sequence[1].value) || {})?.value || null;
      let column3 = (temcurrentGroupedRow.find(x => x.key === sequence[2].value) || {})?.value || null;
      let column4 = (temcurrentGroupedRow.find(x => x.key === sequence[3].value) || {})?.value || null;
      let column5 = (temcurrentGroupedRow.find(x => x.key === sequence[4].value) || {})?.value || null;
      let column6 = (temcurrentGroupedRow.find(x => x.key === sequence[5].value) || {})?.value || null;
      let column7 = (temcurrentGroupedRow.find(x => x.key === sequence[6].value) || {})?.value || null;
      let column8 = (temcurrentGroupedRow.find(x => x.key === sequence[7].value) || {})?.value || null;

      let column9 = (temcurrentGroupedRow.find(x => x.key === sequence[8].value) || {})?.value || null;
      let column10 = (temcurrentGroupedRow.find(x => x.key === sequence[9].value) || {})?.value || null;
      let column11 = (temcurrentGroupedRow.find(x => x.key === sequence[10].value) || {})?.value || null;
      let column12 = (temcurrentGroupedRow.find(x => x.key === sequence[11].value) || {})?.value || null;
      let column13 = (temcurrentGroupedRow.find(x => x.key === sequence[12].value) || {})?.value || null;
      let column14 = (temcurrentGroupedRow.find(x => x.key === sequence[13].value) || {})?.value || null;

      if (d.data !== undefined) {        
        this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      } else {
        const groupColumns = this.state.advanceFilterConfig.groupBy.selected;

        groupColumns?.forEach(g => {
          temcurrentGroupedRow = temcurrentGroupedRow.filter((x) => x.key !== g.value);

          temcurrentGroupedRow.push({ key: g.value, value: d[g.value] });
        });
      }
      const keyvalue = this.adjustColumnSequence(
        _.cloneDeep(temcurrentGroupedRow)
      );
      
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const topBorderClass =
        column1 !==
          (keyvalue.find((x) => x.key === sequence[0].value) || {}).value ?? ''
          ? ' rpt-topBorder '
          : ' ';

      const key =
        d.market +
        d.department +
        d.employeeId +
        '_' +
        rowCount +
        '_' +
        i;
      if (d.data === undefined) {
        tableCell.push(
          <TableRow className={topBorderClass}>
            <TableCell className={evenOddClass + topBorderClass + ' st sticky'}>
              {getFormattedValues(
                column1 !== d[sequence[0].value] && d[sequence[0].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-1 ' +
                evenOddClass +
                ((column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[1].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-2 ' +
                evenOddClass +
                ((column3 !== d[sequence[2].value] || (column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column3 !== d[sequence[2].value] || (column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])) && d[sequence[2].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-3 ' +
                evenOddClass +
                ((column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[3].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-4 ' +
                evenOddClass +
                ((column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[4].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-5 ' +
                evenOddClass +
                ((column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[5].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-6 ' +
                evenOddClass +
                ((column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[6].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-7 ' +
                evenOddClass +
                ((column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[7].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-8 ' +
                evenOddClass +
                ((column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[8].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-9 ' +
                evenOddClass +
                ((column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[9].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-10 ' +
                evenOddClass +
                ((column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[10].value],
                'Text'
              )}{' '}
            </TableCell> 
            <TableCell
              className={
                'st sticky-11 ' +
                evenOddClass +
                ((column12 !== d[sequence[11].value] || column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column12 !== d[sequence[11].value] || column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[11].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-12 ' +
                evenOddClass +
                ((column13 !== d[sequence[12].value] || column12 !== d[sequence[11].value] || column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column13 !== d[sequence[12].value] || column12 !== d[sequence[11].value] || column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[12].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-13 ' +
                evenOddClass +
                ((column14 !== d[sequence[13].value] || column13 !== d[sequence[12].value] || column12 !== d[sequence[11].value] || column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column14 !== d[sequence[13].value] || column13 !== d[sequence[12].value] || column12 !== d[sequence[11].value] || column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[13].value],
                'Text'
              )}{' '}
            </TableCell>       
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.previousAllocationPercent === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.previousAllocationPercent, 'DecimalPercent')}</span>}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.rate === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.rate, 'DecimalPercent')}</span>}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.allocationPercentVariance === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.allocationPercentVariance, 'DecimalPercent')}</span>}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.previousBillingPercent === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.previousBillingPercent, 'DecimalPercent')}</span>}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.billingPercent === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.billingPercent, 'DecimalPercent')}</span>}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.billingPercentVariance === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.billingPercentVariance, 'DecimalPercent')}</span>}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.previousFixedAmount === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.previousFixedAmount, 'MoneyDecimal')}</span>}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.fixedAmount === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.fixedAmount, 'MoneyDecimal')}</span>}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.fixedAmountVariance === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.fixedAmountVariance, 'MoneyDecimal')}</span>}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.billable === null
                ? 'NA'
                : getFormattedValues(d.billable, 'Text')}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.billable === null
                ? 'NA'
                : getFormattedValues(d.billable, 'Text')}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.effectiveFrom === null
                ? 'NA'
                : getFormattedValues(d.effectiveFrom, 'Date')}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.termination_Date === null
                ? 'NA'
                : getFormattedValues(d.effectiveThrough, 'Date')}
            </TableCell>
          </TableRow>
        );
      }
      rowCount++;
      column1 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[0].value) || {}).value ?? null;
      column2 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[1].value) || {}).value ?? null;
      column3 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[2].value) || {}).value ?? null;
      column4 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[3].value) || {}).value ?? null;
      column5 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[4].value) || {}).value ?? null;
      column6 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[5].value) || {}).value ?? null; 
      column7 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[6].value) || {}).value ?? null;
      column8 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[7].value) || {}).value ?? null;

      column9 = (temcurrentGroupedRow.find((x) => x.key === sequence[8].value) || {}).value ?? null;
      column10 = (temcurrentGroupedRow.find((x) => x.key === sequence[9].value) || {}).value ?? null;
      column11 = (temcurrentGroupedRow.find((x) => x.key === sequence[10].value) || {}).value ?? null;
      column12 = (temcurrentGroupedRow.find((x) => x.key === sequence[11].value) || {}).value ?? null;
      column13 = (temcurrentGroupedRow.find((x) => x.key === sequence[12].value) || {}).value ?? null;
      column14 = (temcurrentGroupedRow.find((x) => x.key === sequence[13].value) || {}).value ?? null;
    });
    return tableCell;
  };

  // Close sliding panel
  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  // Download report in excel or pdf format
  downloadFile = (fileMimeType, type, isPrint) => {
    let { market, department, property, employee, endDate, startDate, advanceFilterConfig, designation, SupervisorEmployee,
      controllerEmployee,
      propertyType,
      propertySubType,
      client,
      legalEntity
    } = this.state;
    const dataValue = [
      { key: 'StartDate', value: moment(startDate).format(DateFormat) },
      { key: 'EndDate', value: moment(endDate).format(DateFormat) }
    ];

    market = market.filter(x => x.marketName !== 'All');
    department = department.filter(x => x.departmentName !== 'All');
    property = property.filter(x => x.propertyName !== 'All');
    employee = employee.filter(x => x.employeeName !== 'All');
    SupervisorEmployee = SupervisorEmployee.filter(x => x.employeeName !== 'All');

    controllerEmployee = controllerEmployee.filter(x => x.employeeName !== 'All');
    propertyType = propertyType.filter(x => x.propertyTypeName !== 'All');
    propertySubType = propertySubType.filter(x => x.propertySubTypeName !== 'All');
    client = client.filter(x => x.clientName !== 'All');
    legalEntity = legalEntity.filter(x => x.customerName !== 'All');

    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    const controllerName = _.cloneDeep(controllerEmployee.map((x) => x.employeeName));
    const propertyTypeId = _.cloneDeep(propertyType.map((x) => x.propertyTypeId));
    const propertySubTypeId = _.cloneDeep(propertySubType.map((x) => x.propertySubTypeId));
    const clientId = _.cloneDeep(client.map((x) => x.clientId));
    const legalEntityId = _.cloneDeep(legalEntity.map((x) => x.customerId));

    if (market && market.length > 0) {
      dataValue.push({ key: 'MarketId', value: marketId.join('|') === undefined ? '' : marketId.join('|') });
    }

    if (property && property.length > 0) {
      dataValue.push({ key: 'PropertyId', value: propertyId.join('|') === undefined ? '' : propertyId.join('|') });
    }
    if (department && department.length > 0) {
      dataValue.push({ key: 'DepartmentId', value: departmentId.join('|') === undefined ? '' : departmentId.join('|') });
    }
    if (employee && employee.length > 0) {
      dataValue.push({ key: 'EmployeeId', value: employeeId.join('|') === undefined ? '' : employeeId.join('|') });
    }
    if (SupervisorEmployee && SupervisorEmployee.length > 0) {
      dataValue.push({ key: 'supervisorId', value: supervisorId.join('|') === undefined ? '' : supervisorId.join('|') });
    }

    if (controllerEmployee && controllerEmployee.length > 0) {
      dataValue.push({ key: 'ControllerName', value: (controllerName.join('|') === undefined || controllerName.join('|') === 'All') ? '' : controllerName.join('|') });
    }
    if (propertyType && propertyType.length > 0) {
      dataValue.push({ key: 'PropertyTypeId', value: propertyTypeId.join('|') === undefined ? '' : propertyTypeId.join('|') });
    }
    if (propertySubType && propertySubType.length > 0) {
      dataValue.push({ key: 'PropertySubTypeId', value: propertySubTypeId.join('|') === undefined ? '' : propertySubTypeId.join('|') });
    }
    if (client && client.length > 0) {
      dataValue.push({ key: 'ClientId', value: clientId.join('|') === undefined ? '' : clientId.join('|') });
    }
    if (legalEntity && legalEntity.length > 0) {
      dataValue.push({ key: 'LegalEntityId', value: legalEntityId.join('|') === undefined ? '' : legalEntityId.join('|') });
    }

    const url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Property%20Allocation%20Summary%20Report', type);
    downloadReport(
      url,
      'Property Allocation Summary',
      fileMimeType,
      type,
      isPrint
    );
  }

  // Handle sorting event on table columns
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    }, () => { this.forceUpdate(); });
  };

  // Render table
  renderTable = (employeeData) => {
    const groupSequence = this.getColumnSequence();
    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={employeeData.length}
          columnSequence={groupSequence}
          headCells={headCells}
        />        
        <TableBody>
          {employeeData.length > 0            
            ? this.renderTableRow(employeeData)
            : <label className="item-small">No Data Available.</label>
          }</TableBody>
      </Table>
    );
  };

  Row = ({ index, key, style }) => (
    this.state.UIData[index]
  );

  // Render method to render the components
  render() {
    const {
      showMain,
      employeeData,
      startDate,
      endDate,
      marketMasterData,
      departmentMasterData,
      designationMasterData,
      employeeMasterData,
      // employeeSupervisorList,
      propertyMasterData,
      showReport,
      advanceFilterConfig,
      openSlidingPanel,
      futureEndDate,
      supervisorEmployeeMasterData,
      controllerEmployeeMasterData,
      propertyTypeMasterData,
      propertySubTypeData,
      clientListingMasterData,
      legalEntityMasterData
    } = this.state;
    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (designationMasterData.find(x => x.designation === 'All') === undefined) {
      designationMasterData.unshift({ designation: 'All' });
    }
    if (departmentMasterData.find(x => x.departmentName === 'All') === undefined) {
      departmentMasterData.unshift({ departmentName: 'All' });
    }

    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }

    if (propertyMasterData.find(x => x.propertyName === 'All') === undefined) {
      propertyMasterData.unshift({ propertyName: 'All' });
    }
    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }
    if (propertyTypeMasterData.find(x => x.propertyTypeName === 'All') === undefined) {
      propertyTypeMasterData.unshift({ propertyTypeName: 'All' });
    }
    if (propertySubTypeData.find(x => x.propertySubTypeName === 'All') === undefined) {
      propertySubTypeData.unshift({ propertySubTypeName: 'All' });
    }
    if (clientListingMasterData.find(x => x.clientName === 'All') === undefined) {
      clientListingMasterData.unshift({ clientName: 'All' });
    }
    if (legalEntityMasterData.find(x => x.customerName === 'All') === undefined) {
      legalEntityMasterData.unshift({ customerName: 'All' });
    }
    if (controllerEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      controllerEmployeeMasterData.unshift({ employeeName: 'All' });
    }    

    return (
      <>
        {showMain
          ? (
            <Reports></Reports>
          )
          : (
            <>
              <PageHeader
                key={'Property_Allocation_Summary_Report'}
                title={'Property Allocation Summary Report '}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Property Allocation Summary
              </PageHeader>
              <Grid container spacing={3} className="no-print row top-xs" style={{ marginLeft: '10px' }}>
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.market}
                    onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                    id="tags-standard"
                    options={marketMasterData}
                    limitTags={2}
                    getOptionLabel={(option) => option.marketName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Market"
                      // placeholder="Market"
                      />
                    )}
                  />
                  <Autocomplete
                    blurOnSelect
                    multiple
                    limitTags={2}
                    id="tags-standard"
                    value={this.state.property}
                    options={propertyMasterData}
                    onChange={(e, val) => this.handleChange(e, val, 'property', 'propertyName')}
                    getOptionLabel={(option) => option.propertyName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Property Name"
                      // placeholder="Property Name"
                      />
                    )}
                  />
                  <Autocomplete
                    multiple
                    limitTags={1}
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.SupervisorEmployee || ''}
                    options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                    getOptionLabel={(option) => option.employeeName}
                    onChange={(e, val) => {
                      this.handleChange(e, val, 'SupervisorEmployee', 'employeeName');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Supervisor Name"                    
                      />
                    )}
                  />                                                                  
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.department}
                    onChange={(e, val) => this.handleChange(e, val, 'department', 'departmentName')}
                    options={departmentMasterData}
                    limitTags={2}
                    getOptionLabel={(option) => option.departmentName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Home Department"
                      // placeholder="Department"
                      />
                    )}
                  />
                  <Autocomplete
                    multiple
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.propertyType}
                    onChange={(e, val) => this.handleChange(e, val, 'propertyType', 'propertyTypeName')}
                    options={propertyTypeMasterData}
                    limitTags={2}
                    getOptionLabel={(option) => option.propertyTypeName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Property Type"
                      />
                    )}
                  />
                  <Autocomplete
                    multiple
                    limitTags={1}
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.controllerEmployee || ''}
                    options={removeDuplicates(controllerEmployeeMasterData, 'employeeName')}
                    getOptionLabel={(option) => option.employeeName}
                    onChange={(e, val) => {
                      this.handleChange(e, val, 'controllerEmployee', 'employeeName');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Controller Name"
                      // placeholder="Employee Name"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.client || ''}
                    options={removeDuplicates(clientListingMasterData, 'clientName')}
                    getOptionLabel={(option) => option.clientName}
                    onChange={(e, val) => {
                      this.handleChange(e, val, 'client', 'clientName');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Client"                      
                      />
                    )}
                  />
                  <Autocomplete
                    multiple
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.propertySubType}
                    onChange={(e, val) => this.handleChange(e, val, 'propertySubType', 'propertySubTypeName')}
                    options={propertySubTypeData}
                    limitTags={2}
                    getOptionLabel={(option) => option.propertySubTypeName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Property Sub Type"
                      />
                    )}
                  />            
                </Grid>  
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.legalEntity || ''}
                    options={removeDuplicates(legalEntityMasterData, 'customerName')}
                    getOptionLabel={(option) => option.customerName}
                    onChange={(e, val) => {
                      this.handleChange(e, val, 'legalEntity', 'customerName');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Legal Entity"
                      />
                    )}
                  />
                  <Autocomplete
                    multiple
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.employee}
                    onChange={(e, val) =>
                      this.handleChange(e, val, 'employee', 'employeeName')
                    }
                    options={employeeMasterData}
                    limitTags={2}
                    getOptionLabel={(option) => option.employeeName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Employee Name"
                      // placeholder="Title"
                      />
                    )}
                  />                                                    
                </Grid>  
                <Grid item xs={12} lg={2}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Pay Period(From)"
                        format="MM/dd/yyyy"
                        name="startDate"
                        // maxDate={endDate}
                        value={startDate}
                        onChange={(e) => this.handleDateChange(e, 'startDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                        shouldDisableDate={this.disableDatesForPayCycleStart}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Pay Period(To)"
                        format="MM/dd/yyyy"
                        name="endDate"
                        minDate={startDate}
                        // maxDate={moment().endOf('month').format('MM/DD/YYYY')}
                        value={endDate}
                        maxDate={futureEndDate}
                        onChange={(e) => this.handleDateChange(e, 'endDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                        shouldDisableDate={this.disableDatesForPayCycleEnd}
                        maxDateMessage='Please select date within two Pay Periods'
                      />
                    </Grid>
                  </MuiPickersUtilsProvider> 
                </Grid>                              
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  data={employeeData}
                  downloadFile={this.downloadFile}
                />                
              </Grid>
              <div className="col-lg-3 buttons">
                <div className="col-lg-12">
                  <AdvancedFilter
                    filterConfig={advanceFilterConfig}
                    onApplyFilter={this.onAddvanceFilterChange}
                    openSlidingPanel={openSlidingPanel}
                    handleClose={this.handleClose}
                  />
                </div>
              </div>
              {/* If Auto Run is not enabled and buttons not clicked, then show message to click button */}
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (employeeData === null || employeeData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {/* If no data is found then show then message */}
              {showReport && (employeeData.length === 0 || employeeData === null) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {this.state.showReport && (
                <div>
                  {employeeData !== null && employeeData.length > 0 && (
                    //   <div className="container" style={{ marginTop: '2px' }}>
                    //     <TableContainer component={Paper}>
                    //       {/* <Preview id={'table-pdf'} width={'1200'} height={'210'}> */}
                    //       {this.renderTable(employeeData)}
                    //       {/* </Preview> */}
                    //     </TableContainer>
                    //   </div>
                    <TableWithPaginations
                      tableData={employeeData}
                      renderTable={this.renderTable}
                      // expand={expand}
                      order={this.state.order}
                      oBy={this.state.orderBy}
                      sortData={this.getMultilevelGroupedSortedData}
                    // handleCollapse={handleCollapse}
                    />
                  )}
                </div>
              )}
            </>
          )}
      </>
    );
  }
}
